import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeTwo from './HomeTwo';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Product from './pages/shop/Products';
import ProductCategory from './pages/shop/ProductCategory';
import ProductDetails from './pages/shop/ProductDetails';
import Quote from './pages/quote/Quote';

function App() {
    return (
        <Router>
            <GlobalStyle />
            <ScrollToTop />
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={HomeTwo} />
                <Route path={`${process.env.PUBLIC_URL + "/home-two"}`} component={HomeTwo} />
                <Route path={`${process.env.PUBLIC_URL + "/about"}`} component={About} />
                <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component={Contact} />
                <Route path={`${process.env.PUBLIC_URL + "/product-category"}`} component={ProductCategory} />
                <Route path={`${process.env.PUBLIC_URL + "/products/:category"}`} component={Product} />
                <Route path={`${process.env.PUBLIC_URL + "/product-details/:product_slug"}`} component={ProductDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/quote"}`} component={Quote} />
            </Switch>
        </Router>
    )
}

export default App;